import * as React from 'react';
import moment from 'moment';
import propz from 'propz';
import { AbsenceMessage } from 'Src/models/message';
import {
  ABSENCE_MESSAGE_INTERVAL_SERVER_TO_CLIENT_MAPPING,
  ABSENCE_MESSAGE_REASON_SERVER_TO_CLIENT_MAPPING
} from 'Src/consts/absenceMessage';
import { getFullName } from 'Src/helpers/autocomplete/autocomplete';
import './AbsenceRequestDetails.scss';

interface Props {
  item: AbsenceMessage;
}

export const AbsenceRequestDetails = ({ item }: Props) => {
  const studentName = getFullName(propz.get(item, ['playerDetailsData'], {}));
  const date = propz.get(item, ['dateAbsence'], '');
  const interval = propz.get(item, ['intervalAbsence'], '');
  const reason = propz.get(item, ['reasonAbsence'], '');
  const details = propz.get(item, ['details'], '');
  const authorisedComment = propz.get(item, ['authorizedComment'], '');
  const isAuthorized = propz.get(item, ['isAuthorized']);
  const hasDecision = typeof isAuthorized !== 'undefined';

  return (
    <div className="absenceRequestDetails">
      <div className="absenceRequestDetails__hero">
        <div className="absenceRequestDetails__avatar" aria-hidden="true">
          {studentName.split(' ').map(part => part[0]).slice(0, 2).join('').toUpperCase()}
        </div>
        <div>
          <span>Student</span>
          <strong>{studentName || 'Student'}</strong>
        </div>
        <span className={`absenceRequestDetails__status ${hasDecision ? (isAuthorized ? 'is-approved' : 'is-declined') : ''}`}>
          {hasDecision ? (isAuthorized ? 'Authorised' : 'Not authorised') : 'Pending'}
        </span>
      </div>

      <div className="absenceRequestDetails__grid">
        <div><span>Date</span><strong>{date ? moment(date).format('DD MMM YYYY') : '—'}</strong></div>
        <div><span>Period</span><strong>{ABSENCE_MESSAGE_INTERVAL_SERVER_TO_CLIENT_MAPPING[interval] || '—'}</strong></div>
      </div>

      <section>
        <span>Reason</span>
        <strong>{ABSENCE_MESSAGE_REASON_SERVER_TO_CLIENT_MAPPING[reason] || '—'}</strong>
      </section>
      <section>
        <span>Details</span>
        <p>{details || 'No additional details provided.'}</p>
      </section>
      {authorisedComment && (
        <section className="absenceRequestDetails__response">
          <span>School response</span>
          <p>{authorisedComment}</p>
        </section>
      )}
    </div>
  );
};

AbsenceRequestDetails.displayName = 'AbsenceRequestDetails';
